<template>
  <div
    v-if="internalValue"
    id="applicant-application-as-form"
    class="applicant-show-form"
  >
    <div class="flex flex-wrap flex-row">
      <DataInput
        v-model="internalValue.wantedOccupation"
        type="text"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Bewerbung als"
        name="wantedOccupation"
      />

      <DataInput
        v-model="internalValue.wantedOccupations"
        type="model"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Berufe"
        name="wantedOccupations"
        multiple
        set-last-element-null
        gql-query="occupations"
      />

      <DataInput
        v-model="internalValue.wantedJobTypes"
        type="model"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Stellenarten"
        name="jobTypes"
        gql-query="vacancyJobTypes"
        set-last-element-null
        multiple
      />

      <!-- <DataInput
        v-model="internalValue.placementTypes"
        type="model"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Vermittlungsarten"
        name="placementTypes"
        gql-query="applicantPlacementTypes"
        set-last-element-null
        multiple
      /> -->

      <DataInput
        v-model="internalValue.profileNote"
        type="html"
        class="w-full mt-4 pr-3"
        label="Ich suche"
        name="profileNote"
      />
      <h2 class="mt-5 w-full">Verfügbarkeit</h2>
      <DataInput
        v-model="internalValue.availibiltyID"
        :initial-value="internalValue.availibilty"
        type="model"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Verfügbarkeit"
        name="availibilty"
        gql-query="applicantAvailibilities"
      />
      <DataInput
        v-model="internalValue.availibiltyCustom"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Verfügbar ab"
        name="availibiltyCustom"
      />

      <h2 class="mt-5 w-full">Mobilität</h2>
      <DataInput
        v-model="internalValue.mobilityComment"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Mobilität"
        name="mobilityComment"
      />

      <DataInput
        v-model="internalValue.mobilityRadius"
        type="number"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="im Umkreis von"
        name="mobilityRadius"
      />

      <DataInput
        v-model="internalValue.ownCar"
        type="bool"
        class="w-full md:w-1/3 lg:w-1/5 mt-4 pr-3"
        label="Eigener PKW?"
        name="ownCar"
      />

      <DataInput
        v-model="internalValue.mobilityMotorcycle"
        type="bool"
        class="w-full md:w-1/3 lg:w-1/5 mt-4 pr-3"
        label="Eigenes Motorrad?"
        name="mobilityMotorcycle"
      />

      <DataInput
        v-model="internalValue.mobilityBicycle"
        type="bool"
        class="w-full md:w-1/3 lg:w-1/5 mt-4 pr-3"
        label="Eigenes Fahrrad?"
        name="mobilityBicycle"
      />

      <DataInput
        v-model="internalValue.mobilityPublicTransport"
        type="bool"
        class="w-full md:w-1/3 lg:w-1/5 mt-4 pr-3"
        label="ÖPNV (z.B. Bus/Bahn)?"
        name="mobilityPublicTransport"
      />

      <DataInput
        v-model="internalValue.driverLicenses"
        type="model"
        class="w-full md:w-1/2 mt-4 pr-3"
        label="Führerscheine"
        name="driverLicenses"
        multiple
        set-last-element-null
        gql-query="applicantDriverLicenses"
      />
    </div>
    <h2 class="mt-5 w-full">Gehaltsvorstellungen</h2>
    <div class="flex flex-wrap flex-row">
      <DataInput
        v-model="internalValue.salaryIs"
        class="w-full md:w-1/3 mt-4 pr-3"
        label="Gehalt ist"
        name="salaryIs"
      />

      <DataInput
        v-model="internalValue.salaryCar"
        class="w-full md:w-1/3 mt-4 pr-3"
        label="PKW"
        name="salaryCar"
      />
      <DataInput
        v-model="internalValue.salaryWanted"
        class="w-full md:w-1/3 mt-4 pr-3"
        label="Gehalt Soll"
        name="salaryWanted"
      />
      <DataInput
        v-model="internalValue.salaryFix"
        class="w-full md:w-1/3 mt-4 pr-3"
        label="Gehalt Aufteilung fix"
        name="salaryFix"
      />

      <DataInput
        v-model="internalValue.salaryVariable"
        class="w-full md:w-1/3 mt-4 pr-3"
        label="Gehalt Aufteilung variabel"
        name="salaryVariable"
      />
    </div>

    <h2 class="mt-5 w-full">Zusätzliche Informationen</h2>
    <div class="flex flex-wrap flex-row ">
      <div class="vx-col w-full md:w-1/4">
        <DataInput
          v-model="internalValue.degree"
          type="select"
          :options="degrees"
          class="w-full mt-4 pr-3"
          label="Abschluss"
          name="degree"
        />
      </div>
      <div class="vx-col w-full md:w-1/4">
        <DataInput
          v-model="internalValue.leadershipExperienceID"
          :initial-value="internalValue.leadershipExperience"
          type="model"
          class="w-full mt-4 pr-3"
          label="Personalverantwortung"
          name="leadershipExperience"
          gql-query="applicantLeadershipExperiences"
        />
      </div>
      <div class="vx-col w-full md:w-1/4">
        <DataInput
          v-model="internalValue.jobExperienceID"
          :initial-value="internalValue.jobExperience"
          type="model"
          class="w-full mt-4 pr-3"
          label="Berufserfahrung"
          name="jobExperience"
          gql-query="applicantJobExperiences"
        />
      </div>
      <div class="vx-col w-full md:w-1/4">
        <DataInput
          v-model="internalValue.hobbies"
          type="select"
          multiple
          taggable
          push-tags
          :options="[]"
          class="w-full mt-4 pr-3"
          label="Hobbies"
          name="salaryVariable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import salutations from "@/data/enums/Salutation.js";
import salutationTypes from "@/data/enums/SalutationType.js";
import civilStates from "@/data/enums/CivilStatus.js";
import degrees from "@/data/enums/Degree.js";

export default {
  components: {
    DataInput
  },
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    degrees,
    salutations,
    salutationTypes,
    civilStates
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler: function(v) {
        this.internalValue = v;
      }
    },
    internalProfileValue: {
      deep: true,
      handler: function(v) {
        this.internalProfileValue = v;
      }
    }
  }
};
</script>
